function Sectors() {
  return (
    <div className="p-10">
      <h1 className="text-3xl font-bold">Sectors Page</h1>
    </div>
  );
}

export default Sectors;